<template>
  <div class="news-container container fade-in">
    <h1 class="text-center mb-4">最新资讯</h1>
    <div class="news-filter">
      <input type="text" v-model="searchQuery" placeholder="搜索新闻..." class="search-input">
    </div>
    <div class="news-list">
      <div v-for="news in filteredNews" :key="news.id" class="news-item">
        <div class="news-date">{{ news.date }}</div>
        <h3>{{ news.title }}</h3>
        <p class="news-excerpt">{{ news.excerpt }}</p>
        <a href="#" class="read-more">阅读更多</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsPage',
  data() {
    return {
      searchQuery: '',
      news: [
        {
          id: 1,
          title: '2024年度艺术展览即将开幕',
          date: '2024-06-15',
          excerpt: '我们将于下月举办年度大型艺术展览，汇聚国内外知名艺术家的作品，敬请期待。'
        },
        {
          id: 2,
          title: '平台新增虚拟展厅功能',
          date: '2024-06-10',
          excerpt: '我们很高兴地宣布，平台新增了虚拟展厅功能，让您足不出户就能欣赏到精美的艺术作品。'
        },
        {
          id: 3,
          title: '艺术家访谈系列：走进创作者的内心世界',
          date: '2024-06-05',
          excerpt: '我们推出了全新的艺术家访谈系列，带您深入了解艺术家的创作历程和灵感来源。'
        },
        {
          id: 4,
          title: '平台用户突破10万，感谢一路相伴',
          date: '2024-05-28',
          excerpt: '在大家的支持下，我们的平台用户数突破了10万大关，感谢每一位用户的信任和陪伴。'
        }
      ]
    }
  },
  computed: {
    filteredNews() {
      if (!this.searchQuery) {
        return this.news
      }
      return this.news.filter(item => 
        item.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        item.excerpt.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    }
  },
  mounted() {
    console.log('新闻页面已加载')
  }
}
</script>

<style scoped>
.news-container {
  padding: 1rem;
}

.news-filter {
  margin-bottom: 30px;
  text-align: center;
}

.search-input {
  width: 100%;
  max-width: 500px;
  padding: 12px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
}

.search-input:focus {
  border-color: #42b983;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.news-item {
  padding: 25px;
  border: 1px solid #eee;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.news-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.news-date {
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 10px;
}

.news-item h3 {
  color: #333;
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.news-excerpt {
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.read-more {
  color: #42b983;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s;
}

.read-more:hover {
  color: #35a36d;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .news-container h1 {
    font-size: 2rem;
  }
  
  .news-item h3 {
    font-size: 1.3rem;
  }
}
</style>